import React from 'react';
import './AppWindow.css';

const AppWindow = ({ isOpen, onClose, title, children, width = 800, height = 600, noScroll = false }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="app-window"
        style={{ width: `${width}px`, height: `${height}px` }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="window-titlebar">
          <div className="window-controls">
            <button className="control-btn close" onClick={onClose}></button>
            <button className="control-btn minimize"></button>
            <button className="control-btn maximize"></button>
          </div>
          <div className="window-title">{title}</div>
          <div className="window-controls-spacer"></div>
        </div>
        <div className={`window-content ${noScroll ? 'no-scroll' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppWindow;